<template>
  <div class="navCont">
    <div class="autoWidth">
      <el-menu
        :default-active="$router.currentRoute.name"
        class="el-menu-demo float-l"
        mode="horizontal"
        @select="handleSelect"
        background-color="#333333"
        text-color="#ffffff"
        active-text-color="#ffd04b"
      >
        <el-menu-item class="logo" index="aaa">
          <router-link to="/index"
            ><img src="../assets/image/logo-word.png" alt=""
          /></router-link>
        </el-menu-item>
        <el-menu-item index="Recharge">
          <router-link to="/recharge/index" class="nav-item">
            {{ $t("recharge") }}
          </router-link>
        </el-menu-item>

        <el-submenu index="2" class="indexNav">
          <template slot="title">{{ $t("persion") }}</template>
          <router-link to="/myGame/index">
            <el-menu-item index="MyGame">{{ $t("myGame") }}</el-menu-item>
          </router-link>
          <router-link to="/order/index">
            <el-menu-item index="Order">{{ $t("myOrder") }}</el-menu-item>
          </router-link>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">{{ $t("customer") }}</template>
          <router-link to="/issues/index">
            <el-menu-item index="Issues">{{ $t("hotQuestion") }}</el-menu-item>
          </router-link>
          <router-link to="/customer/index">
            <el-menu-item index="Customer">{{
              $t("connectService")
            }}</el-menu-item>
          </router-link>
        </el-submenu>
      </el-menu>
      <div class="float-r">
        <Language class="float-r" />
        <InOut class="float-r" />
      </div>
    </div>
  </div>
</template>

<script>
import InOut from "./inOut";
import Language from "./language";
export default {
  data() {
    return {};
  },
  components: {
    InOut,
    Language,
  },
  methods: {
    handleSelect(key, keyPath) {},
  },
};
</script>
<style lang="scss" scoped>
.navCont {
  height: 80px;
  background-color: #333333;
}
.el-menu-demo {
  text-align: center;
  border: none !important;
  margin: 0 auto;
  .nav-item {
    display: inline-block;
    height: 80px;
    width: 100%;
  }
  .el-menu-item {
    height: 80px;
    line-height: 80px;
    min-width: 140px;
    font-size: 16px;
  }
  .logo {
    width: 180px;
    height: 80px;
    img {
      width: 158px;
      height: auto;
      margin-top: -10px;
    }
  }
  .logo:hover {
    background-color: none;
  }
}
</style>
<style lang="scss">
.el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 80px !important;
  line-height: 80px !important;
  border-bottom: 2px solid transparent !important;
  font-size: 16px !important;
}
</style>


// WEBPACK FOOTER //
// src/page/navigation.vue